// src/components/Certificates/Certificates.js
import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Certificates.css';
import img1 from "../../assets/Certificate/img (1).png";
import img2 from "../../assets/Certificate/img (2).png";
import img3 from "../../assets/Certificate/img (3).png";
import img4 from "../../assets/Certificate/img (4).png";

const Certificates = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const certifications = [
    {
      id: 1,
      title: "IATF 16949:2016",
      detail: "Automotive Quality Management System",
      // Use placeholder or local path. This is a common IATF logo URL for demo.
      imgUrl: img1 
    },
    {
      id: 2,
      title: "Customer Green Certification",
      detail: "Maruti Suzuki - Green Certified Supplier",
      // Placeholder for the Maruti Suzuki Green badge
      imgUrl: img2
    },
    {
      id: 3,
      title: "ISO 45001:2018",
      detail: "Occupational Health & Safety Management",
      // Placeholder for ISO 45001
      imgUrl: img3
    },
    {
      id: 4,
      title: "ISO 14001",
      detail: "Environmental Management System",
      // Placeholder for ISO 14001 green leaf logo
      imgUrl: img4
    }
  ];

  return (
    <section className="certificates-section" id="facilities">
      <Container>
        {/* Header Content */}
        <div data-aos="fade-down">
          <h2 className="cert-heading">Quality & Certifications</h2>
          <p className="cert-desc">
            We follow internationally recognized quality management systems
            to ensure consistent performance, compliance, and reliability
            across all manufacturing processes.
          </p>
        </div>

        {/* Certificates Grid */}
        <Row className="justify-content-center">
          {certifications.map((cert, index) => (
            <Col lg={3} md={6} sm={12} key={cert.id} className="mb-4">
              <div 
                className="cert-card" 
                data-aos="fade-up" 
                data-aos-delay={index * 100} // Staggers the animation for each card
              >
                {/* Logo Area */}
                <div className="cert-img-wrapper">
                  <img 
                    src={cert.imgUrl} 
                    alt={cert.title} 
                    className="cert-logo" 
                  />
                </div>
                
                {/* Orange Footer */}
                <div className="cert-footer">
                  <div className="cert-name">{cert.title}</div>
                  <div className="cert-details">{cert.detail}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Certificates;